export const DUPLICATE_CONVERSION_VALUES = {
  DISABLE: 0,
  ENABLE: -1,
  TIME_LIMIT: 1,
};

export const ROUTE_CONTAINER_TYPES = {
  CALL_PLAN: 'callPlan',
  CAMPAIGN: 'campaign'
};


//
export const DEFAULT_DATA_IF_RPC = {
  priority: 1,
  weight: 1
};

export const CONVERSION_TYPES = {
  CALL_LENGTH: 'callLength',
  REVENUE_TARGET: 'revenueTarget',
  PAYOUT: 'payout',
  POSTBACK: 'postBack',
};

export const validRowContainerTypes = [ROUTE_CONTAINER_TYPES.CAMPAIGN, ROUTE_CONTAINER_TYPES.CALL_PLAN];